import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { click } from '@tracking';
import { transformToSnakeCase } from '@utils/formatting';

import { TextButton } from '../Button/variants';
import LogoTIWithIconTI from '../Images/Rebranding/LogoTIWithIconTI';
import { MAIN_LINK_ITEMS } from './footerItems';

const Links = () => {
  const { trackEvent } = useEventTracking();

  return (
    <div className="flex flex-col justify-start">
      <div className="flex flex-nowrap items-center">
        <LogoTIWithIconTI className="h-48 text-white" />
      </div>
      <ul className="mb-0 mt-48 list-none pl-0">
        {MAIN_LINK_ITEMS.map(({ href, name }) => (
          <li key={name} className="mt-8 first:mt-0">
            <TextButton
              className="!justify-start font-suisse-works text-body-lg text-white no-underline hover:opacity-100 sm:text-feed-headline-sm"
              as="link"
              key={href}
              href={href}
              onClickCapture={() => trackEvent(click({ clickTarget: transformToSnakeCase(name) }))}
            >
              {name}
            </TextButton>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Links;
